import { render, staticRenderFns } from "./HeroCarousel.vue?vue&type=template&id=a3309f10&scoped=true&"
import script from "./HeroCarousel.vue?vue&type=script&lang=js&"
export * from "./HeroCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HeroCarousel.vue?vue&type=style&index=0&id=a3309f10&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3309f10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCarousel,VCarouselItem,VImg})
